module.exports = __webpack_public_path__ + "img/partner15.5a951386.png";